import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useProducts } from "components/products/hooks/useProducts";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";

export default function ViewProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadProductById } = useProducts();

  const [data, setData] = useState(null);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    loadProductById(id).then(setData);
  }, [id]);

  const formatPrice = (price, currency) => {
  if (!price) return "-";

  if (!currency) return `${price}`;

  return `${currency.symbol} ${Number(price).toFixed(2)}`;
};

  if (!data) return <p className="p-6">Loading...</p>;

  const product = data.data || data;
  

  return (
    <div className="p-6 space-y-8">

      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Product Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

      <Card title="Product Information">
        <Info label="Product Name" value={product.product_name} />
        <Info
          label="Price"
          value={formatPrice(product.price, product.currency_id)}
        />
        <Info label="Status" value={product.status} />
        <Info
          label="Sample Available"
          value={product.is_sample ? "Yes" : "No"}
        />
        {product.is_sample && (
        <Card title="Sample Availability">
            <Info
            label="Start Date"
            value={new Date(product.sample_start_date).toLocaleString()}
            />
            <Info
            label="End Date"
            value={new Date(product.sample_end_date).toLocaleString()}
            />
        </Card>
        )}


        <Info label="Website" value={product.website} />
        <Info
          label="Short Description"
          value={product.short_description}
        />
      </Card>

      <Card title="Exhibitor Information">
        <Info
          label="Exhibitor"
          value={product.exhibitor_id?.title}
        />
      </Card>

      <Card title="Category Information">
        <Info
          label="Product Category"
          value={product.product_category_id?.title}
        />
      </Card>

      {product.productImages?.length > 0 && (
        <Card title="Product Images">
          <div className="flex flex-wrap gap-4 col-span-2">
            {product.productImages
              .filter(Boolean)
              .map((img, index) => (
                <img
                  key={index}
                  src={getImageUrl(img)}
                  alt="Product"
                  className="h-24 w-auto rounded-xl border cursor-pointer object-contain"
                  onClick={() => {
                    setActiveImage(img);
                    setViewerOpen(true);
                  }}
                />
              ))}
          </div>

          <ImageViewer
            open={viewerOpen}
            onClose={() => setViewerOpen(false)}
            src={getImageUrl(activeImage)}
          />
        </Card>
      )}
    </div>
  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
